import { render, staticRenderFns } from "./MainPrivacyPolicy.vue?vue&type=template&id=84c6f530&scoped=true&"
import script from "./MainPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./MainPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./MainPrivacyPolicy.vue?vue&type=style&index=0&id=84c6f530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c6f530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
